import { formatMonthLabel } from '../engines/dateUtils';
/* yearColumns.js -- THE ANNUAL COLUMN LABEL (2026-11-02, the one-month start; diffs/one-month-start-build.txt B4).
 *
 * A year the window does not fill says so: "2026 (Oct-Dec)" (an en dash), or "2026 (Oct)" for a single month. A whole
 * calendar year reads as before, "2026". The same idea quarterColumns applies to a partial quarter.
 *
 * WHY: a company that starts in October shows a 2026 column over three months; read as "2026" it looks like a full
 * year's total. Every live company's window is whole calendar years (a January start, a December end), so their labels
 * do not change.
 *
 * @param {number} year
 * @param {string[]} months  the window's months in that year, in order (a window holds each month once, so 12 = whole)
 * @returns {string}
 */
export function yearLabel(year, months) {
    const ms = months || [];
    if (!ms.length || ms.length >= 12) return String(year);
    const first = formatMonthLabel(ms[0], 'short');
    const last = formatMonthLabel(ms[ms.length - 1], 'short');
    return `${year} (${ms.length === 1 ? first : first + '\u2013' + last})`;
}
